import { render } from "./App-Onboard.vue?vue&type=template&id=2fda0e42&ts=true"
import script from "./App-Onboard.vue?vue&type=script&lang=ts"
export * from "./App-Onboard.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__